package horcrux.frontend.common.views.navigation

import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.configs.StaticContentConfigs.BLUE
import horcrux.frontend.common.configs.StaticContentConfigs.WHITE
import mui.icons.material.KeyboardArrowDown
import mui.icons.material.KeyboardArrowUp
import mui.material.Fab
import mui.material.FabVariant
import mui.system.sx
import react.FC
import react.Props
import react.dom.aria.ariaLabel

external interface ShowManageCollectionsButtonProps : Props {
    var globalAppState: GlobalAppState
}

val ShowCollectionNavigatorButton = FC<ShowManageCollectionsButtonProps> { props ->
    val defaultLabel = "Manage Collections"
    val label = props.globalAppState.currentCollectionMetadataMaybeState.get()?.collectionName?.betterToString()
        ?.take(defaultLabel.length) ?: defaultLabel
    Fab {
        if (props.globalAppState.shouldShowCollectionNavigatorState.get()) {
            KeyboardArrowUp {}
        } else {
            KeyboardArrowDown {}
        }

        +label
        this.variant = FabVariant.extended
        this.sx {
            this.color = WHITE
            this.backgroundColor = BLUE
        }
        this.ariaLabel = "Manage Collections"
        this.onClick = {
            props.globalAppState.toggleShowCollectionNavigatorState()
        }
    }
}
